import {Button} from "antd";
import styled from "styled-components";

export const StyledPageWrapper = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: calc(7.101rem + 4rem) 2rem 4rem;
`;

export const StyledCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  max-width: 673px;
  min-height: 426px;
  text-align: center;
`;

export const StyledIconCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f6ffed;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledHeading = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.2rem;
`;

export const StyledDescription = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.65);
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const StyledActionButton = styled(Button)`
  width: 100%;
  height: 46px;
  border-radius: 12px;
  padding: 12px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
